import config from "../config.js";

const DEFAULT_HUB_HOSTS = [
  "dev.routeeye.io",
  "app.routeeye.io",
  "www.routeeye.io",
  "routeeye.io",
];

const LOCAL_HOSTS = new Set(["localhost", "127.0.0.1"]);

export function normalizeHostname(value) {
  const raw = String(value || "").trim().toLowerCase();
  if (!raw) return "";
  try {
    if (raw.includes("://")) {
      return new URL(raw).hostname.replace(/\.$/, "");
    }
  } catch {
    /* fall through */
  }
  return raw.split("/")[0].split(":")[0].replace(/\.$/, "");
}

function parseHubHosts() {
  const fromEnv = String(config.hubHosts || "")
    .split(",")
    .map((host) => normalizeHostname(host))
    .filter((host) => host.includes("."));
  return fromEnv.length > 0 ? fromEnv : DEFAULT_HUB_HOSTS;
}

export function getCurrentHostname() {
  if (typeof window === "undefined") return "";
  return normalizeHostname(window.location.hostname);
}

export function isLocalHostname(hostname = getCurrentHostname()) {
  return LOCAL_HOSTS.has(hostname);
}

export function isHubHostname(hostname = getCurrentHostname()) {
  if (!hostname || isLocalHostname(hostname)) return false;
  if (parseHubHosts().includes(hostname)) return true;
  const base = normalizeHostname(config.tenantBaseDomain);
  if (base && (hostname === base || hostname === `www.${base}`)) return true;
  return false;
}

export function resolveTenantHostname(organization) {
  const appHostname = normalizeHostname(organization?.appHostname);
  if (appHostname) return appHostname;

  const slug = String(organization?.subdomainSlug || "")
    .trim()
    .toLowerCase();
  const base = normalizeHostname(config.tenantBaseDomain);
  if (slug && base) return `${slug}.${base}`;
  return "";
}

export function getSharedAuthCookieDomain(hostname = getCurrentHostname()) {
  if (!hostname || isLocalHostname(hostname)) return undefined;
  if (hostname === "dev.routeeye.io" || hostname.endsWith(".dev.routeeye.io")) {
    return ".dev.routeeye.io";
  }
  if (hostname === "routeeye.io" || hostname.endsWith(".routeeye.io")) {
    return ".routeeye.io";
  }
  return undefined;
}

export function shouldRedirectToTenant(organization) {
  const tenantHost = resolveTenantHostname(organization);
  const currentHost = getCurrentHostname();
  if (!tenantHost || isLocalHostname(currentHost)) return false;
  return tenantHost !== currentHost;
}
